import React from "react";

import {
  bidPart,
  pipelinePart,
  strategyPart,
  tenderPart,
  together,
} from "../../../lib/icons/CustomIcons";

import css from "./LargeCallToAction.module.scss";

type Props = {
  header: string;
  content: string;
  buttonLink: string;
};

export default function LargeCallToAction({ header, content, buttonLink }: Props) {
  return (
    <div className={css.container}>
      <div className={css.leftIcons}>
        {together}
        {strategyPart}
        {pipelinePart}
        {tenderPart}
        {bidPart}
      </div>
      <div className={css.contentContainer}>
        <div className={css.iconContainer}>
          {together}
          {strategyPart}
          {pipelinePart}
          {tenderPart}
          {bidPart}
        </div>
        <h2>{header}</h2>
        <p>{content}</p>
        <button onClick={() => window.open(buttonLink, "_blank")}>Get started free</button>
      </div>
      <div className={css.rightIcons}>
        {together}
        {strategyPart}
        {pipelinePart}
        {tenderPart}
        {bidPart}
      </div>
    </div>
  );
}
